/* ============================================================
   SR KIT 50ml AB — Lógica del rediseño (Dossier-style) Serené
   Scoped al template collection.crea-tu-kit-50-ml-ab.
   - Tag de cards por código S### (dataset curado, sin inventar)
   - Nav horizontal + buscador + drawer de filtros + sort
   - Sticky bar informativa de progreso del kit (lee /cart.js)
   Datos rellenados desde CSVs curados serene_*.csv + colecciones de género.
   Cobertura: familia/clima/ocasión ~96%, género ~98%, marca ~94%.
   ============================================================ */
(function () {
  'use strict';

  var DATA = {"S840": {"f": "Amaderada", "c": "Frío", "o": "Noche", "g": "U", "b": "Bleecker Street"}, "S089": {"f": "Cítrica", "c": "Cálido", "o": "Eventos", "g": "H", "b": "Club De Nuit"}, "S030": {"f": "Aromática", "c": "Frío", "o": "Noche", "g": "H", "b": "Christian Dior"}, "S841": {"f": "Amaderada", "c": "Frío", "o": "Día a día", "g": "U", "b": "Le Labo"}, "S842": {"f": "Amaderada", "c": "Frío", "o": "Noche", "g": "U", "b": "Louis Vuitton"}, "S071": {"f": "Aromática", "c": "Cálido", "o": "Eventos", "g": "H", "b": "Creed", "x": ["Más vendida", "Nueva"]}, "S090": {"f": "Cítrica", "c": "Cálido", "o": "Día a día", "g": "U", "b": "Xerjoff", "x": ["Más vendida", "Nueva"]}, "S834": {"f": "Floral", "c": "Frío", "o": "Cita", "g": "U", "b": "Maison Francis Kurkdjian"}, "S032": {"f": "Aromática", "c": "Cálido", "o": "Día a día", "g": "H", "b": "Cartier"}, "S031": {"f": "Aromática", "c": "Cálido", "o": "Trabajo", "g": "H", "b": "Chanel"}, "S023": {"f": "Amaderada", "c": "Frío", "o": "Noche", "g": "H", "b": "Valentino"}, "S033": {"f": "Cítrica", "c": "Cálido", "o": "Día a día", "g": "H", "b": "Giorgio Armani", "x": ["Más vendida"]}, "S832": {"f": "Amaderada", "c": "Frío", "o": "Noche", "g": "U", "b": "Tom Ford"}, "S240": {"f": "Floral", "c": "Frío", "o": "Día a día", "g": "M", "b": "Valentino"}, "S034": {"f": "Aromática", "c": "Cálido", "o": "Día a día", "g": "H", "b": "Paco Rabanne"}, "S230": {"f": "Floral", "c": "Frío", "o": "Eventos", "g": "M", "b": "Chanel"}, "S232": {"f": "Floral", "c": "Frío", "o": "Cita", "g": "M", "b": "Carolina Herrera"}, "S036": {"f": "Amaderada", "c": "Frío", "o": "Cita", "g": "H"}, "S239": {"f": "Floral", "c": "Frío", "o": "Día a día", "g": "M", "b": "Ariana Grande"}, "S054": {"f": "Cítrica", "c": "Cálido", "o": "Trabajo", "g": "H", "b": "Issey Miyake"}, "S233": {"f": "Floral", "c": "Frío", "o": "Cita", "g": "M", "b": "Lancome"}, "S014": {"f": "Cítrica", "c": "Cálido", "o": "Día a día", "g": "H", "b": "Armaf"}, "S053": {"f": "Aromática", "c": "Cálido", "o": "Día a día", "g": "H", "b": "Bvlgari"}, "S838": {"f": "Floral", "c": "Frío", "o": "Cita", "g": "U", "b": "Tom Ford"}, "S070": {"f": "Amaderada", "c": "Cálido", "o": "Día a día", "g": "U", "b": "Dior"}, "S029": {"f": "Amaderada", "c": "Frío", "o": "Noche", "g": "H", "b": "Jean Paul Gaultier"}, "S831": {"f": "Amaderada", "c": "Frío", "o": "Noche", "g": "U", "b": "Al Haramain"}, "S011": {"f": "Aromática", "c": "Cálido", "o": "Día a día", "g": "H", "b": "Christian Dior"}, "S807": {"f": "Floral", "c": "Cálido", "o": "Eventos", "g": "U", "b": "Kayali"}, "S016": {"f": "Cítrica", "c": "Cálido", "o": "Día a día", "g": "H", "b": "Giorgio Armani"}, "S861": {"f": "Amaderada", "c": "Frío", "o": "Noche", "g": "U", "b": "Lattafa Perfumes"}, "S069": {"f": "Aromática", "c": "Cálido", "o": "Trabajo", "g": "H", "b": "Creed"}, "S010": {"f": "Cítrica", "c": "Cálido", "o": "Día a día", "g": "H", "b": "Louis Vuitton"}, "S026": {"f": "Aromática", "c": "Frío", "o": "Noche", "g": "H", "b": "Jean Paul Gaultier"}, "S238": {"f": "Floral", "c": "Cálido", "o": "Trabajo", "g": "M", "b": "Chanel"}, "S205": {"f": "Floral", "c": "Frío", "o": "Cita", "g": "M", "b": "Marly"}, "S830": {"f": "Floral", "c": "Frío", "o": "Cita", "g": "U", "b": "Maison Francis Kurkdjian"}, "S025": {"f": "Aromática", "c": "Frío", "o": "Cita", "g": "H", "b": "Emporio Armani"}, "S234": {"f": "Floral", "c": "Frío", "o": "Eventos", "g": "M", "b": "Paco Rabanne"}, "S231": {"f": "Floral", "c": "Cálido", "o": "Eventos", "g": "M", "b": "Christian Dior", "x": ["Más vendida"]}, "S003": {"g": "H", "b": "Prada"}, "S237": {"f": "Amaderada", "c": "Frío", "o": "Cita", "g": "M", "b": "Dior"}, "S024": {"f": "Amaderada", "c": "Frío", "o": "Noche", "g": "H", "b": "Bharara"}, "S002": {"f": "Amaderada", "c": "Frío", "o": "Noche", "g": "H", "b": "Jean Paul Gaultier"}, "S860": {"f": "Aromática", "c": "Cálido", "o": "Día a día", "g": "U", "b": "Marly"}, "S859": {"f": "Cítrica", "c": "Cálido", "o": "Día a día", "g": "U", "b": "Louis Vuitton"}, "S245": {"f": "Floral", "c": "Cálido", "o": "Día a día", "g": "M", "b": "Bond No 9"}, "S811": {"f": "Amaderada", "c": "Frío", "o": "Noche", "g": "U", "b": "Orientica"}, "S837": {"f": "Amaderada", "c": "Frío", "o": "Noche", "g": "U", "b": "Tom Ford", "x": ["Más vendida", "Nueva"]}, "S835": {"f": "Amaderada", "c": "Frío", "o": "Noche", "g": "U", "b": "Maison Francis Kurkdjian"}, "S076": {"f": "Cítrica", "c": "Cálido", "o": "Día a día", "g": "H", "b": "D&G", "x": ["Más vendida"]}, "S210": {"f": "Floral", "c": "Frío", "o": "Cita", "g": "M", "b": "Lataffa"}, "S214": {"f": "Floral", "c": "Cálido", "o": "Eventos", "g": "M", "b": "Dior"}, "S222": {"f": "Floral", "c": "Cálido", "o": "Día a día", "g": "M", "b": "Chanel"}, "S818": {"f": "Amaderada", "c": "Frío", "o": "Noche", "g": "U", "b": "Xerjoff"}, "S019": {"f": "Amaderada", "c": "Frío", "o": "Cita", "g": "H", "b": "Afnan"}, "S013": {"f": "Cítrica", "c": "Cálido", "o": "Trabajo", "g": "H", "b": "Chanel"}, "S098": {"f": "Cítrica", "c": "Cálido", "o": "Día a día", "g": "H", "b": "Versace"}, "S021": {"f": "Cítrica", "c": "Frío", "o": "Noche", "g": "H", "b": "Paco Rabanne"}, "S236": {"f": "Floral", "c": "Cálido", "o": "Eventos", "g": "M", "b": "Chanel"}, "S252": {"f": "Floral", "c": "Cálido", "o": "Eventos", "g": "M", "b": "Carolina Herrera"}, "S814": {"f": "Amaderada", "c": "Frío", "o": "Noche", "g": "U", "b": "Ilmin"}, "S853": {"f": "Cítrica", "c": "Cálido", "o": "Día a día", "g": "U", "b": "Al Haramain"}, "S211": {"f": "Floral", "c": "Cálido", "o": "Día a día", "g": "M", "b": "Ariana Grande"}, "S028": {"f": "Cítrica", "c": "Cálido", "o": "Día a día", "g": "H", "b": "Valentino"}, "S001": {"f": "Aromática", "c": "Cálido", "o": "Día a día", "g": "H", "b": "Carolina Herrera"}, "S202": {"f": "Floral", "c": "Frío", "o": "Día a día", "g": "M", "b": "Lattafa"}, "S243": {"f": "Floral", "c": "Cálido", "o": "Eventos", "g": "U", "b": "Creed"}, "S253": {"f": "Amaderada", "c": "Frío", "o": "Cita", "g": "M"}, "S803": {"f": "Aromática", "c": "Frío", "o": "Cita", "g": "U", "b": "Club De Nuit Untold"}, "S091": {"f": "Aromática", "c": "Cálido", "o": "Día a día", "g": "H", "b": "Valentino", "x": ["Más vendida", "Nueva"]}, "S017": {"f": "Cítrica", "c": "Cálido", "o": "Día a día", "g": "H", "b": "Louis Vuitton"}, "S022": {"f": "Amaderada", "c": "Cálido", "o": "Día a día", "g": "H", "b": "Jean Paul Gaultier"}, "S204": {"f": "Floral", "c": "Frío", "o": "Cita", "g": "M", "b": "Dolce&Gabbana"}, "S852": {"f": "Amaderada", "c": "Frío", "o": "Noche", "g": "U", "b": "Al Haramain"}, "S248": {"f": "Floral", "c": "Frío", "o": "Eventos", "g": "M", "b": "Creed"}, "S247": {"f": "Floral", "c": "Frío", "o": "Eventos", "g": "M", "b": "Armaf"}, "S849": {"f": "Amaderada", "c": "Frío", "o": "Noche", "g": "U", "b": "Lataffa"}, "S229": {"f": "Floral", "c": "Cálido", "o": "Día a día", "g": "M", "b": "Versace"}, "S215": {"f": "Amaderada", "c": "Frío", "o": "Eventos", "g": "M", "b": "Carolina Herrera"}, "S817": {"f": "Amaderada", "c": "Frío", "o": "Noche", "g": "H", "b": "Maison Martin Margiela"}, "S015": {"f": "Aromática", "c": "Frío", "o": "Noche", "g": "H", "b": "Paco Rabanne"}, "S203": {"f": "Floral", "c": "Frío", "o": "Cita", "g": "M", "b": "Hugo Boss"}, "S043": {"f": "Amaderada", "c": "Cálido", "o": "Trabajo", "g": "H", "b": "Hermes"}, "S241": {"f": "Floral", "c": "Frío", "o": "Cita", "g": "M", "b": "Kayali"}, "S820": {"f": "Amaderada", "c": "Frío", "o": "Noche", "g": "U", "b": "Lattafa"}, "S223": {"f": "Floral", "c": "Cálido", "o": "Día a día", "g": "M", "b": "Carolina Herrera"}, "S804": {"f": "Floral", "c": "Frío", "o": "Cita", "g": "U", "b": "Bleecker Street"}, "S226": {"f": "Floral", "c": "Cálido", "o": "Día a día", "g": "M"}, "S220": {"f": "Floral", "c": "Cálido", "o": "Día a día", "g": "M", "b": "Moschino"}, "S850": {"f": "Amaderada", "c": "Frío", "o": "Noche", "g": "U", "b": "Rabanne"}, "S808": {"f": "Aromática", "c": "Cálido", "o": "Día a día", "g": "U", "b": "Bal d'Afrique"}, "S004": {"f": "Aromática", "c": "Frío", "o": "Noche", "g": "H", "b": "Calvin Klein"}, "S094": {"f": "Amaderada", "c": "Cálido", "o": "Día a día", "g": "U", "b": "Salvatore Ferragamo"}, "S063": {"f": "Amaderada", "c": "Frío", "o": "Eventos", "g": "H", "b": "Montblanc"}, "S206": {"f": "Floral", "c": "Frío", "o": "Cita", "g": "M", "b": "Jean Paul Gaultier"}, "S213": {"f": "Floral", "c": "Cálido", "o": "Día a día", "g": "M", "b": "Ralph Lauren"}, "S856": {"f": "Floral", "c": "Cálido", "o": "Día a día", "g": "U", "b": "Bond No 9"}, "S815": {"f": "Cítrica", "c": "Cálido", "o": "Día a día", "g": "U", "b": "Creed"}, "S822": {"g": "U", "b": "Ahli"}, "S020": {"f": "Aromática", "c": "Frío", "o": "Cita", "g": "H", "b": "Hugo Boss"}, "S217": {"f": "Amaderada", "c": "Frío", "o": "Cita", "g": "M", "b": "Paco Rabanne"}, "S228": {"f": "Floral", "c": "Cálido", "o": "Día a día", "g": "M", "b": "Victoria's Secret"}, "S218": {"f": "Floral", "c": "Cálido", "o": "Día a día", "g": "M", "b": "Giorgio Armani"}, "S035": {"f": "Aromática", "c": "Frío", "o": "Cita", "g": "H", "b": "Giorgio Armani"}, "S212": {"f": "Amaderada", "c": "Frío", "o": "Día a día", "g": "M", "b": "Lattafa"}, "S259": {"f": "Floral", "c": "Cálido", "o": "Día a día", "g": "M", "b": "Montale"}, "S806": {"b": "Kayali"}, "S258": {"f": "Floral", "c": "Cálido", "o": "Día a día", "g": "M", "b": "Paris Hilton"}, "S254": {"f": "Floral", "c": "Frío", "o": "Cita", "g": "M"}, "S250": {"f": "Cítrica", "c": "Cálido", "o": "Eventos", "g": "M"}, "S261": {"f": "Floral", "c": "Frío", "o": "Cita", "g": "M", "b": "Jean Paul Gaultier"}, "S246": {"f": "Floral", "c": "Frío", "o": "Cita", "g": "M", "b": "Bvlgari"}, "S249": {"f": "Aromática", "c": "Cálido", "o": "Día a día", "g": "M"}, "S201": {"f": "Floral", "c": "Cálido", "o": "Día a día", "g": "M", "b": "Amouage"}, "S251": {"f": "Floral", "c": "Cálido", "o": "Día a día", "g": "M", "b": "Tommy Hilfiger"}, "S857": {"f": "Cítrica", "c": "Cálido", "o": "Día a día", "g": "U", "b": "The Fireplace By Maison Martin Margiela"}, "S813": {"f": "Amaderada", "c": "Frío", "o": "Noche", "g": "U", "b": "Montale"}, "S018": {"f": "Aromática", "c": "Cálido", "o": "Día a día", "g": "H", "b": "Loewe"}, "S863": {"f": "Amaderada", "c": "Frío", "o": "Noche", "g": "U", "b": "Lattafa"}, "S833": {"f": "Cítrica", "c": "Cálido", "o": "Trabajo", "g": "U", "b": "Maison Francis Kurkdjian", "x": ["Más vendida", "Nueva"]}, "S810": {"f": "Amaderada", "c": "Frío", "o": "Noche", "g": "U", "b": "Orientica"}, "S227": {"f": "Floral", "c": "Cálido", "o": "Día a día", "g": "M", "b": "Versace"}, "S216": {"f": "Amaderada", "c": "Frío", "o": "Noche", "g": "M", "b": "Mugler"}, "S855": {"f": "Floral", "c": "Cálido", "o": "Día a día", "g": "U", "b": "Armaf"}, "S854": {"f": "Amaderada", "c": "Frío", "o": "Noche", "g": "U", "b": "Le Labo"}, "S805": {"g": "U", "b": "Kayali"}, "S257": {"f": "Floral", "c": "Cálido", "o": "Día a día", "g": "M"}, "S260": {"f": "Floral", "c": "Frío", "o": "Cita", "g": "U", "b": "Bharara"}, "S858": {"f": "Amaderada", "c": "Frío", "o": "Noche", "g": "U", "b": "Diptyque"}, "S242": {"f": "Floral", "c": "Frío", "o": "Noche", "g": "U", "b": "Al Haramain"}, "S225": {"f": "Floral", "c": "Frío", "o": "Eventos", "g": "M", "b": "Givenchy"}, "S244": {"f": "Floral", "c": "Cálido", "o": "Día a día", "g": "U", "b": "Glossier"}, "S801": {"f": "Amaderada", "c": "Frío", "o": "Noche", "g": "U", "b": "Kayali"}, "S851": {"b": "Le Labo"}};
  var GEN = { H: 'Hombre', M: 'Mujer', U: 'Unisex' };
  // Marcas "nicho" presentes en el catálogo (para chip Nicho)
  var NICHE = ['Maison Francis Kurkdjian', 'Xerjoff', 'Le Labo', 'Amouage', 'Montale',
    'Creed', 'Tom Ford', 'Louis Vuitton', 'Diptyque', 'Marly', 'Bond No 9',
    'Bleecker Street', 'Orientica', 'The Fireplace By Maison Martin Margiela'];
  // Marcas para el filtro de inspiración (curadas: las reconocibles con presencia real)
  var BRAND_FILTERS = ['Christian Dior', 'Lancome', 'Chanel', 'Carolina Herrera', 'Xerjoff',
    'Maison Francis Kurkdjian', 'Le Labo', 'Creed', 'Tom Ford', 'Giorgio Armani', 'Valentino',
    'Paco Rabanne', 'Rabanne', 'Jean Paul Gaultier', 'Versace', 'Louis Vuitton', 'Prada',
    'Lattafa', 'Armaf', 'Club De Nuit'];

  function scode(t) { var m = /\bS(\d{2,4})\b/i.exec(t || ''); return m ? ('S' + m[1]) : null; }
  function norm(s) { return (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''); }
  function $(s, c) { return (c || document).querySelector(s); }
  function $all(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  var grid, items = [], noResultsEl, countEl;
  // estado
  var state = { nav: 'todos', filters: { g: [], f: [], c: [], o: [], b: [] }, q: '', sort: 'rel' };

  /* ---------- 1. Indexar y taguear las cards ---------- */
  function indexCards() {
    grid = $('#product-grid');
    if (!grid) return false;
    items = $all('.grid__item', grid).filter(function (li) {
      return $('.card-wrapper', li) || $('.card', li);
    });
    items.forEach(function (li, i) {
      var titleEl = $('.card__heading', li) || $('.card__information', li);
      var title = titleEl ? titleEl.textContent.trim() : '';
      var code = scode(title);
      var d = (code && DATA[code]) ? DATA[code] : {};
      li._srk = {
        i: i, title: norm(title), code: code || '',
        g: d.g || '', f: d.f || '', c: d.c || '', o: d.o || '',
        b: d.b || '', x: d.x || [],
        niche: d.b ? NICHE.indexOf(d.b) > -1 : false
      };
      decorateCard(li, d);
    });
    return true;
  }

  function decorateCard(li, d) {
    var wrap = $('.card-wrapper', li) || li;
    var inner = $('.card__inner', li) || $('.card__media', li);
    // badges (máx 2, sin saturar)
    if (inner && !$('.srk-cardbadges', li)) {
      var badges = [];
      if (d.x && d.x.indexOf('Más vendida') > -1) badges.push(['best', 'Más vendida']);
      if (d.x && d.x.indexOf('Nueva') > -1) badges.push(['new', 'Nueva']);
      if (badges.length < 2 && d.o === 'Noche') badges.push(['noche', 'Noche']);
      if (badges.length) {
        if (getComputedStyle(wrap).position === 'static') wrap.style.position = 'relative';
        var box = document.createElement('div');
        box.className = 'srk-cardbadges';
        box.innerHTML = badges.slice(0, 2).map(function (b) {
          return '<span class="srk-cardbadge srk-cardbadge--' + b[0] + '">' + b[1] + '</span>';
        }).join('');
        wrap.appendChild(box);
      }
    }
    // etiqueta "Inspirada en {marca}" bajo el título
    var head = $('.card__heading', li);
    if (head && d.b && !$('.srk-cardinsp', li)) {
      var span = document.createElement('span');
      span.className = 'srk-cardinsp';
      span.innerHTML = 'Inspirada en <b>' + d.b + '</b>';
      var holder = head.closest('.card__information') || head.parentNode;
      head.parentNode.insertBefore(span, head.nextSibling);
    }
  }

  /* ---------- 2. Predicados de filtrado ---------- */
  function navMatch(s) {
    switch (state.nav) {
      case 'todos': return true;
      case 'best': return s.x.indexOf('Más vendida') > -1;
      case 'H': case 'M': case 'U': return s.g === state.nav;
      case 'calidas': return s.c === 'Cálido';
      case 'frescas': return s.c === 'Frío';
      case 'noche': return s.o === 'Noche';
      case 'diaria': return s.o === 'Día a día';
      case 'trabajo': return s.o === 'Trabajo';
      case 'nicho': return s.niche;
      default: return true;
    }
  }
  function filterMatch(s) {
    var f = state.filters;
    if (f.g.length && f.g.indexOf(s.g) < 0) return false;
    if (f.f.length && f.f.indexOf(s.f) < 0) return false;
    if (f.c.length && f.c.indexOf(s.c) < 0) return false;
    if (f.o.length && f.o.indexOf(s.o) < 0) return false;
    if (f.b.length && f.b.indexOf(s.b) < 0) return false;
    return true;
  }
  function searchMatch(s) {
    if (!state.q) return true;
    return s.title.indexOf(state.q) > -1 || norm(s.b).indexOf(state.q) > -1;
  }

  function applyFilters() {
    var visible = 0;
    items.forEach(function (li) {
      var s = li._srk;
      var ok = navMatch(s) && filterMatch(s) && searchMatch(s);
      li.classList.toggle('srk-hidden', !ok);
      if (ok) visible++;
    });
    applySort();
    if (countEl) countEl.innerHTML = '<b>' + visible + '</b> ' + (visible === 1 ? 'fragancia disponible' : 'fragancias disponibles');
    if (noResultsEl) noResultsEl.classList.toggle('show', visible === 0);
    updateFilterBarState();
    var n = activeFilterCount();
    $all('.srk-badge-count').forEach(function (b) {
      b.textContent = n; b.classList.toggle('show', n > 0);
    });
    // banners visibles solo en vista por defecto (sin filtro/búsqueda/orden)
    var defaultView = state.nav === 'todos' && n === 0 && !state.q && state.sort === 'rel';
    toggleBanners(defaultView);
    setFiltering(!defaultView);
  }

  /* ---------- banners intercalados en la grilla ---------- */
  var gridBanners = [];
  function injectGridBanners() {
    if (!grid) return;
    var defs = [
      { after: 4, cls: 'dark', txt: 'Arma tu kit con 8 fragancias para diferentes momentos.', cta: 'Elegir mis favoritas', act: 'shortcut:todos' },
      { after: 12, cls: 'light', txt: '¿Buscas algo <span>dulce, fresco o intenso</span>?', cta: 'Usar filtros', act: 'filter' },
      { after: 22, cls: 'soft', txt: 'Completa tus 8 fragancias y finaliza tu kit.', cta: 'Ver mi kit', act: 'cart' }
    ];
    defs.forEach(function (d) {
      var ref = items[d.after - 1];
      if (!ref) return;
      var li = document.createElement('li');
      li.className = 'grid__item srk-gridbanner srk-gridbanner--' + d.cls;
      li.innerHTML = '<span class="srk-gridbanner__txt">' + d.txt + '</span>' +
        '<button type="button" class="srk-gridbanner__cta" data-srk-banner="' + d.act + '">' + d.cta + '</button>';
      if (ref.nextSibling) grid.insertBefore(li, ref.nextSibling); else grid.appendChild(li);
      gridBanners.push(li);
    });
    grid.addEventListener('click', function (e) {
      var b = e.target.closest('[data-srk-banner]');
      if (!b) return;
      var act = b.dataset.srkBanner;
      if (act === 'filter') { var f = $('[data-srk-open="filter"]'); if (f) f.click(); }
      else if (act === 'cart') { openCart(); }
      else if (act.indexOf('shortcut:') === 0) {
        var p = $('.srk-pill[data-nav="' + act.split(':')[1] + '"]'); if (p) p.click();
        var a = $('#srk-grid-anchor'); if (a) a.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }
  function toggleBanners(show) { gridBanners.forEach(function (li) { li.classList.toggle('srk-hidden', !show); }); }

  /* ---------- mostrar/ocultar cuadrícula vs secciones curadas ----------
     Vista por defecto: cuadrícula oculta (CSS) + secciones editoriales visibles.
     Al filtrar/buscar: cuadrícula filtrada visible + editoriales ocultas,
     para que el usuario vea solo los resultados de la colección. */
  var editorialSecs = null;
  function collectEditorials() {
    editorialSecs = $all('[id*="shopify-section-template--"]').filter(function (s) {
      var id = s.id;
      if (/__main-collection-product-grid/.test(id)) return false; // la cuadrícula
      if (/__srk_/.test(id)) return false;                         // nav / hero / runtime propios
      return true;
    });
  }
  function setFiltering(on) {
    document.documentElement.classList.toggle('srk-filtering', on);
    if (editorialSecs) editorialSecs.forEach(function (s) { s.style.display = on ? 'none' : ''; });
  }

  /* ---------- relabel botón "Sumar al kit" (sobrio, solo cards) ---------- */
  function relabelAddButtons() {
    $all('#product-grid .card .quick-add__submit, #product-grid .card .product-form__submit').forEach(function (b) {
      if (/recibir|contra entrega|pago/i.test(b.textContent)) return; // respeta botón COD EasySell
      if (!/agregar|añadir|carrito|add to cart/i.test(b.textContent)) return;
      var span = b.querySelector('span:not(.svg-wrapper)') || b;
      span.textContent = 'Sumar al kit';
    });
  }

  /* ---------- silent add: el botón de la card suma al carrito SIN abrir
     el quick-view modal nativo de Shrine ni redirigir a la product page.
     Mismo comportamiento que la 30ml (silent add directo). Solo JS, no toca
     template/snippet/grid. Intercepta en CAPTURE para ganarle al listener
     nativo de <product-form>/quick-add. ---------- */
  // Devuelve (y cachea en la card) la promesa de la variante. Cachear permite
  // prefetch en pointerdown → al hacer click la variante ya está lista (sin espera).
  function variantFromCard(card) {
    if (card._variantP) return card._variantP;
    var inp = $('input[name="id"]', card);
    if (inp && inp.value) { card._variantP = Promise.resolve(inp.value); return card._variantP; }
    var a = $('a[href*="/products/"]', card);
    var m = a && a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    if (!m) { card._variantP = Promise.resolve(null); return card._variantP; }
    card._variantP = fetch('/products/' + m[1] + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var vs = p.variants || [];
        var v = vs.filter(function (x) { return x.available; })[0] || vs[0];
        return v ? v.id : null;
      }).catch(function () { card._variantP = null; return null; }); // permite reintento si falló
    return card._variantP;
  }

  function setSectionInner(html, selector) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var src = doc.querySelector(selector), dst = document.querySelector(selector);
    if (src && dst) dst.innerHTML = src.innerHTML;
  }

  function btnFeedback(btn) {
    var span = btn.querySelector('span:not(.svg-wrapper)') || btn;
    var prev = btn._srkLabel || span.textContent;
    btn._srkLabel = prev;
    span.textContent = '✓ Agregado';
    btn.classList.add('srk-added');
    clearTimeout(btn._srkT);
    btn._srkT = setTimeout(function () {
      span.textContent = btn._srkLabel || 'Sumar al kit';
      btn.classList.remove('srk-added');
    }, 1200);
  }

  function silentAdd(btn) {
    if (btn._srkBusy) return;
    var card = btn.closest('.grid__item') || btn.closest('.card-wrapper') || btn.closest('.card');
    if (!card) return;
    btn._srkBusy = true;

    // ---- FEEDBACK OPTIMISTA (instantáneo, antes de la red) ----
    var wasAdded = !!btn._srkAdded;
    paintBtn(btn, true);                                   // botón naranja ya
    var prevCount = kitCount < 0 ? 0 : kitCount;
    var optimistic = prevCount + 1;
    var crosses = prevCount < 8 && optimistic >= 8;        // este add COMPLETA el kit
    renderKit(optimistic);                                 // barra sube ya

    // pide el HTML del drawer SOLO en el add que completa (payload menor en 1 y 2)
    var sections = crosses ? 'cart-icon-bubble,cart-drawer' : 'cart-icon-bubble';

    variantFromCard(card).then(function (id) {
      if (!id) throw new Error('novariant');
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1, sections: sections, sections_url: window.location.pathname })
      });
    }).then(function (r) {
      if (!r.ok) throw new Error('add');
      return r.json();
    }).then(function (data) {
      if (data && data.sections) {
        setSectionInner(data.sections['cart-icon-bubble'], '#cart-icon-bubble');
        if (data.sections['cart-drawer']) updateDrawer(data.sections['cart-drawer']);
      }
      kitCount = optimistic;
      if (crosses) openKitDrawer();                        // abre YA (drawer ya viene fresco)
      refreshKit();                                        // reconcilia conteo/botones en segundo plano
      btn._srkBusy = false;
    }).catch(function () {
      // revertir el optimismo si el add falló
      paintBtn(btn, wasAdded);
      refreshKit();
      btn._srkBusy = false;
    });
  }

  function wireSilentAdd() {
    // Escucha a nivel documento en CAPTURE para cubrir tanto el grid principal
    // (#product-grid, quick-add nativo) como las cards de las colecciones
    // destacadas (featured-collection, botón inyectado). Filtra solo botones
    // que estén dentro de una product card y NUNCA dentro del carrito.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.srk-kitbtn, .quick-add__submit, .product-form__submit, button[name="add"]');
      if (!btn) return;
      if (!btn.closest('.card-wrapper, .card, .grid__item')) return;       // solo cards
      if (btn.closest('cart-drawer, #CartDrawer, .cart-drawer, .drawer, .cart, .cart-notification')) return; // nunca el carrito
      if (/recibir|contra entrega|pago/i.test(btn.textContent)) return;    // respeta COD EasySell
      e.preventDefault();
      e.stopImmediatePropagation();
      silentAdd(btn);
    }, true); // CAPTURE: gana al handler nativo de Shrine

    // PREFETCH: al apretar (antes del click) ya disparamos la consulta de la
    // variante, así el add es casi instantáneo cuando el dedo se levanta.
    document.addEventListener('pointerdown', function (e) {
      var btn = e.target.closest('.srk-kitbtn, .quick-add__submit, button[name="add"]');
      if (!btn) return;
      var card = btn.closest('.grid__item') || btn.closest('.card-wrapper') || btn.closest('.card');
      if (card && $('a[href*="/products/"]', card)) variantFromCard(card);
    }, true);
  }

  /* ---------- inyectar botón "Sumar al kit" en las cards de las colecciones
     DESTACADAS (featured-collection) que vienen SIN quick-add nativo
     (enable_quick_add off). Solo JS, no toca el template. Idempotente. ---------- */
  function injectKitButtons() {
    // estilo propio (NO usar clase quick-add__submit: en Shrine es position:absolute
    // y queda gigante sobre la imagen). Botón en flujo normal, z-index alto para
    // quedar sobre el overlay-link de la card y recibir el tap (evita el redirect).
    var CSS = 'display:block;width:100%;box-sizing:border-box;position:relative;z-index:4;' +
      'margin:10px 0 0;padding:11px 12px;border:0;border-radius:10px;cursor:pointer;' +
      'background:#010767;color:#fff;font-family:inherit;font-weight:700;font-size:13.5px;' +
      'line-height:1.2;text-align:center;letter-spacing:.01em;-webkit-appearance:none;appearance:none';
    var secs = $all('[id*="__featured_collection_"]');
    secs.forEach(function (sec) {
      $all('.card-wrapper', sec).forEach(function (card) {
        if ($('.quick-add__submit', card) || $('.srk-kitbtn', card)) return; // ya tiene botón
        var link = $('a[href*="/products/"]', card);
        if (!link) return;
        // Shrine renderiza el contenido 2 veces: overlay (sobre la imagen) + visible
        // (debajo, con el precio). Insertar SIEMPRE en el visible = el .card__content
        // que contiene .card-information (bloque del precio). Si no, queda sobre la foto.
        var priceBlock = $('.card-information', card) || $('.price', card);
        var host = (priceBlock && priceBlock.closest('.card__content')) ||
                   (priceBlock && priceBlock.parentNode) ||
                   $('.card__content', card) || card;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'srk-kitbtn';
        btn.setAttribute('style', CSS);
        btn.textContent = 'Sumar al kit';
        host.appendChild(btn);
      });
    });
  }

  function activeFilterCount() {
    var f = state.filters, n = 0;
    for (var k in f) n += f[k].length;
    return n;
  }

  /* ---------- 3. Sort (sobre las visibles) ---------- */
  function applySort() {
    if (state.sort === 'rel') return; // orden nativo de la colección
    var vis = items.filter(function (li) { return !li.classList.contains('srk-hidden'); });
    vis.sort(function (a, b) {
      var sa = a._srk, sb = b._srk;
      switch (state.sort) {
        case 'az': return sa.title.localeCompare(sb.title);
        case 'best': return (sb.x.indexOf('Más vendida') > -1) - (sa.x.indexOf('Más vendida') > -1);
        case 'new': return (sb.x.indexOf('Nueva') > -1) - (sa.x.indexOf('Nueva') > -1);
        case 'calidas': return (sb.c === 'Cálido') - (sa.c === 'Cálido');
        case 'frescas': return (sb.c === 'Frío') - (sa.c === 'Frío');
      }
      return 0;
    });
    vis.forEach(function (li) { grid.appendChild(li); });
  }

  /* ---------- 4. Nav pills ---------- */
  function wireNav() {
    var nav = $('.srk-nav__scroll');
    if (!nav) return;
    nav.addEventListener('click', function (e) {
      var pill = e.target.closest('.srk-pill');
      if (!pill) return;
      $all('.srk-pill', nav).forEach(function (p) { p.classList.remove('is-active'); });
      pill.classList.add('is-active');
      state.nav = pill.dataset.nav;
      applyFilters();
    });
  }

  /* ---------- 5. Buscador ---------- */
  function wireSearch() {
    var input = $('#srk-search-input'), clear = $('.srk-search__clear');
    if (!input) return;
    var t;
    input.addEventListener('input', function () {
      clear.classList.toggle('show', !!input.value);
      clearTimeout(t);
      t = setTimeout(function () { state.q = norm(input.value.trim()); applyFilters(); }, 160);
    });
    clear.addEventListener('click', function () {
      input.value = ''; state.q = ''; clear.classList.remove('show'); applyFilters(); input.focus();
    });
  }

  /* ---------- 6. Drawer de filtros + sort ---------- */
  var GROUPS = [
    { key: 'g', title: 'Género', opts: [['H', 'Hombre'], ['M', 'Mujer'], ['U', 'Unisex']] },
    { key: 'f', title: 'Familia olfativa', opts: [['Cítrica', 'Cítrica'], ['Amaderada', 'Amaderada'], ['Aromática', 'Aromática'], ['Floral', 'Floral']] },
    { key: 'c', title: 'Clima ideal', opts: [['Cálido', 'Cálido / dulce'], ['Frío', 'Fresco / frío']] },
    { key: 'o', title: 'Ocasión', opts: [['Día a día', 'Diario'], ['Trabajo', 'Oficina'], ['Cita', 'Citas'], ['Noche', 'Noche'], ['Eventos', 'Eventos']] }
  ];

  function buildBrandOpts() {
    // marcas únicas presentes (curadas) con al menos 1 producto
    var present = {};
    items.forEach(function (li) { if (li._srk.b) present[li._srk.b] = true; });
    var seen = {}, out = [];
    BRAND_FILTERS.forEach(function (b) {
      if (present[b] && !seen[b]) { seen[b] = 1; out.push([b, b === 'Rabanne' ? 'Paco Rabanne' : (b === 'Christian Dior' ? 'Dior' : b)]); }
    });
    return out;
  }

  function buildDrawer() {
    var groups = GROUPS.slice();
    var bopts = buildBrandOpts();
    if (bopts.length) groups.push({ key: 'b', title: 'Inspiración', opts: bopts });

    var ov = document.createElement('div'); ov.className = 'srk-drawer-overlay';
    var dr = document.createElement('aside'); dr.className = 'srk-drawer'; dr.setAttribute('role', 'dialog'); dr.setAttribute('aria-label', 'Filtros');
    var body = groups.map(function (g) {
      return '<div class="srk-fgroup"><p class="srk-fgroup__title">' + g.title + '</p><div class="srk-fopts">' +
        g.opts.map(function (o) {
          return '<button type="button" class="srk-fopt" data-g="' + g.key + '" data-v="' + o[0].replace(/"/g, '') + '">' + o[1] + '</button>';
        }).join('') + '</div></div>';
    }).join('');
    dr.innerHTML =
      '<div class="srk-drawer__head"><h3>Filtrar</h3><button class="srk-drawer__close" aria-label="Cerrar">&times;</button></div>' +
      '<div class="srk-drawer__body">' + body + '</div>' +
      '<div class="srk-drawer__foot"><button class="srk-clear">Limpiar</button><button class="srk-apply">Ver resultados</button></div>';
    document.body.appendChild(ov); document.body.appendChild(dr);

    // sort drawer
    var sov = document.createElement('div'); sov.className = 'srk-drawer-overlay';
    var sdr = document.createElement('aside'); sdr.className = 'srk-drawer'; sdr.setAttribute('role', 'dialog'); sdr.setAttribute('aria-label', 'Ordenar');
    var SORTS = [['rel', 'Relevancia'], ['best', 'Más vendidas'], ['az', 'Nombre A-Z'], ['new', 'Nuevas'], ['calidas', 'Cálidas / dulces'], ['frescas', 'Frescas']];
    sdr.innerHTML =
      '<div class="srk-drawer__head"><h3>Ordenar</h3><button class="srk-drawer__close" aria-label="Cerrar">&times;</button></div>' +
      '<div class="srk-drawer__body"><ul class="srk-sortlist">' +
      SORTS.map(function (s) { return '<li><button type="button" data-s="' + s[0] + '"' + (s[0] === 'rel' ? ' class="is-on"' : '') + '>' + s[1] + '</button></li>'; }).join('') +
      '</ul></div>';
    document.body.appendChild(sov); document.body.appendChild(sdr);

    function openD(o, d) { o.classList.add('open'); d.classList.add('open'); document.documentElement.style.overflow = 'hidden'; }
    function closeAll() {
      [ov, dr, sov, sdr].forEach(function (x) { x.classList.remove('open'); });
      document.documentElement.style.overflow = '';
    }
    // open buttons
    $all('[data-srk-open="filter"]').forEach(function (b) { b.addEventListener('click', function () { openD(ov, dr); }); });
    $all('[data-srk-open="sort"]').forEach(function (b) { b.addEventListener('click', function () { openD(sov, sdr); }); });
    ov.addEventListener('click', closeAll); sov.addEventListener('click', closeAll);
    $all('.srk-drawer__close').forEach(function (b) { b.addEventListener('click', closeAll); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

    // toggle filter opts
    dr.addEventListener('click', function (e) {
      var btn = e.target.closest('.srk-fopt');
      if (btn) {
        var g = btn.dataset.g, v = btn.dataset.v, arr = state.filters[g];
        var idx = arr.indexOf(v);
        if (idx > -1) { arr.splice(idx, 1); btn.classList.remove('is-on'); }
        else { arr.push(v); btn.classList.add('is-on'); }
        applyFilters();
      }
      if (e.target.closest('.srk-apply')) closeAll();
      if (e.target.closest('.srk-clear')) {
        for (var k in state.filters) state.filters[k] = [];
        $all('.srk-fopt', dr).forEach(function (b) { b.classList.remove('is-on'); });
        applyFilters();
      }
    });
    // sort select
    sdr.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-s]');
      if (!btn) return;
      $all('[data-s]', sdr).forEach(function (b) { b.classList.remove('is-on'); });
      btn.classList.add('is-on');
      state.sort = btn.dataset.s;
      applyFilters();
      closeAll();
    });
  }

  /* ---------- 7. Help cards (atajos a filtros) ---------- */
  function wireHelp() {
    $all('[data-srk-shortcut]').forEach(function (el) {
      el.addEventListener('click', function () {
        var nav = el.dataset.srkShortcut;
        var pill = $('.srk-pill[data-nav="' + nav + '"]');
        if (pill) pill.click();
        var anchor = $('#srk-grid-anchor') || grid;
        if (anchor) anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* ---------- barra de filtros inline (dropdowns estilo Dossier) ---------- */
  var fpop;
  function buildFilterBar() {
    var bar = $('.srk-filterbar');
    if (!bar) return;
    var GMAP = {
      g: { opts: [['H', 'Hombre'], ['M', 'Mujer'], ['U', 'Unisex']] },
      f: { opts: [['Cítrica', 'Cítrica'], ['Amaderada', 'Amaderada'], ['Aromática', 'Aromática'], ['Floral', 'Floral']] },
      o: { opts: [['Día a día', 'Día a día'], ['Trabajo', 'Trabajo'], ['Cita', 'Citas'], ['Noche', 'Noche'], ['Eventos', 'Eventos']] },
      b: { opts: buildBrandOpts() }
    };
    fpop = document.createElement('div');
    fpop.className = 'srk-pop';
    document.body.appendChild(fpop);
    var openKey = null;

    function closePop() {
      fpop.classList.remove('open');
      openKey = null;
      $all('.srk-fdrop').forEach(function (b) { b.classList.remove('is-open'); });
    }
    function openPop(key, btn) {
      var grp = GMAP[key];
      if (!grp || !grp.opts.length) return;
      fpop.innerHTML = grp.opts.map(function (o) {
        var on = state.filters[key].indexOf(o[0]) > -1;
        return '<button type="button" class="srk-popopt' + (on ? ' is-on' : '') + '" data-k="' + key + '" data-v="' + o[0].replace(/"/g, '') + '">' + o[1] + '</button>';
      }).join('');
      var r = btn.getBoundingClientRect();
      var w = 232;
      fpop.style.width = w + 'px';
      fpop.style.top = (r.bottom + window.scrollY + 8) + 'px';
      fpop.style.left = Math.max(8, Math.min(r.left + window.scrollX, window.innerWidth - w - 8)) + 'px';
      fpop.classList.add('open');
      btn.classList.add('is-open');
      openKey = key;
    }

    bar.addEventListener('click', function (e) {
      var d = e.target.closest('[data-srk-drop]');
      if (!d) return;
      var key = d.dataset.srkDrop;
      if (openKey === key) closePop();
      else { closePop(); openPop(key, d); }
    });
    fpop.addEventListener('click', function (e) {
      var o = e.target.closest('.srk-popopt');
      if (!o) return;
      var k = o.dataset.k, v = o.dataset.v, arr = state.filters[k], i = arr.indexOf(v);
      if (i > -1) { arr.splice(i, 1); o.classList.remove('is-on'); }
      else { arr.push(v); o.classList.add('is-on'); }
      applyFilters();
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.srk-pop') && !e.target.closest('[data-srk-drop]')) closePop();
    });
    window.addEventListener('resize', closePop);
    document.addEventListener('scroll', function () { if (openKey) closePop(); }, { passive: true });
  }

  function updateFilterBarState() {
    ['g', 'f', 'o', 'b'].forEach(function (k) {
      var n = state.filters[k].length;
      var btn = $('[data-srk-drop="' + k + '"]');
      if (!btn) return;
      btn.classList.toggle('has-active', n > 0);
      var c = btn.querySelector('.srk-fdrop__c');
      if (c) c.textContent = n > 0 ? (' ' + n) : '';
    });
  }

  /* ---------- 8. Sticky bar de progreso (informativa) ---------- */
  var stickyMsg, stickyBar, stickyCta, stickyEl;
  function buildSticky() {
    stickyEl = $('#srk-sticky');
    if (!stickyEl) return;
    stickyMsg = $('.srk-sticky__msg', stickyEl);
    stickyBar = $('.srk-progress__bar', stickyEl);
    stickyCta = $('.srk-sticky__cta', stickyEl);
    stickyCta.addEventListener('click', openCart);
    refreshKit();
    // re-contar tras añadir al carrito
    document.addEventListener('click', function (e) {
      if (e.target.closest('.quick-add__submit, .product-form__submit, [name="add"]')) {
        setTimeout(refreshKit, 1300);
      }
    });
    window.addEventListener('focus', refreshKit);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) refreshKit(); });
  }

  var kitCount = -1;           // unidades de kit 50ml en el carrito (para detectar el paso a 3)
  var completeHandled = false; // ya abrimos el drawer para este "kit completo"
  var firstSync = true;        // el primer conteo (al cargar) NO debe auto-abrir el carrito
  function countKit(cart) {
    var n = 0;
    (cart.items || []).forEach(function (it) {
      var t = (it.product_title || it.title || '');
      if (/\(kit\s*50/i.test(t)) n += it.quantity;
    });
    return n;
  }

  /* ---------- estado visual del botón: agregado = NARANJA persistente ---------- */
  function cardHandle(card) {
    var a = $('a[href*="/products/"]', card);
    var m = a && a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }
  function paintBtn(btn, added) {
    var injected = btn.classList.contains('srk-kitbtn');
    if (added) {
      btn.style.setProperty('background', '#F08400', 'important'); // naranja
      btn.style.setProperty('color', '#fff', 'important');
    } else if (injected) {
      btn.style.setProperty('background', '#010767', 'important');  // azul base
      btn.style.setProperty('color', '#fff', 'important');
    } else {
      btn.style.removeProperty('background');
      btn.style.removeProperty('color');
    }
    var label = added ? '✓ En el kit' : 'Sumar al kit';
    var span = btn.querySelector('span:not(.svg-wrapper)');
    if (span) span.textContent = label; else btn.textContent = label;
    btn.classList.toggle('srk-added', !!added);
    btn._srkAdded = !!added;
  }
  function paintButtonsFromCart(cart) {
    var inCart = {};
    (cart.items || []).forEach(function (it) { if (it.handle) inCart[it.handle] = true; });
    $all('.srk-kitbtn, #product-grid .card .quick-add__submit').forEach(function (btn) {
      var card = btn.closest('.grid__item') || btn.closest('.card-wrapper') || btn.closest('.card');
      if (!card) return;
      var h = cardHandle(card);
      paintBtn(btn, !!(h && inCart[h]));
    });
  }

  function refreshKit(cb) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = countKit(cart), prev = kitCount;
        kitCount = n;
        renderKit(n);
        paintButtonsFromCart(cart);
        if (firstSync) {
          // al cargar: solo sincroniza, nunca auto-abre (aunque ya esté completo)
          completeHandled = n >= 8;
          firstSync = false;
        } else if (n >= 8 && !completeHandled) {
          // red de seguridad: el conteo REAL llegó a 8 y aún no abrimos (optimismo
          // desincronizado) → abrimos. Se resetea al bajar de 8.
          completeHandled = true; openKitDrawer();
        } else if (n < 8) {
          completeHandled = false;
        }
        if (cb) cb(n, prev);
      })
      .catch(function () { });
  }

  /* Poll /cart.js hasta que item_count quede estable (evita abrir el drawer
     mientras apps en background -cart-rewards, EasySell- aún reconcilian). */
  function waitForCartStable(maxMs) {
    return new Promise(function (resolve) {
      var start = Date.now(), lastCount = -1, stableSince = 0, last = null;
      (function poll() {
        fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            last = cart;
            if (cart.item_count === lastCount) {
              if (!stableSince) stableSince = Date.now();
              if (Date.now() - stableSince >= 350) return resolve(cart);
            } else { lastCount = cart.item_count; stableSince = 0; }
            if (Date.now() - start >= maxMs) return resolve(cart);
            setTimeout(poll, 150);
          })
          .catch(function () { resolve(last); });
      })();
    });
  }

  /* Refresca el cart-drawer preservando 'active' y sincronizando 'is-empty'.
     Si el HTML no cambió, NO toca el DOM (evita parpadeo al refrescar). */
  function updateDrawer(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var src = doc.querySelector('cart-drawer'), dst = document.querySelector('cart-drawer');
    if (!src || !dst) { setSectionInner(html, 'cart-drawer'); return; }
    if (dst.innerHTML === src.innerHTML) return;            // sin cambios → sin re-render
    dst.innerHTML = src.innerHTML;
    dst.classList.toggle('is-empty', src.classList.contains('is-empty'));
  }

  /* Abre el cart-drawer lateral al completar las 8 fragancias.
     FLUIDO: el add que completa ya trajo el HTML fresco del drawer, así que
     abrimos de inmediato. Un refresh diferido (700ms) reconcilia por si alguna
     app agregó algo después; updateDrawer omite el re-render si nada cambió. */
  function openKitDrawer() {
    completeHandled = true; // evita que refreshKit lo reabra
    openCart();
    setTimeout(function () {
      fetch('/?sections=cart-drawer,cart-icon-bubble', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (s) {
          setSectionInner(s['cart-icon-bubble'], '#cart-icon-bubble');
          updateDrawer(s['cart-drawer']);
        })
        .catch(function () { });
    }, 700);
  }

  function renderKit(n) {
    if (!stickyEl) return;
    var pct = Math.min(n, 8) / 8 * 100;
    stickyBar.style.width = pct + '%';
    var msg, cta, ready = false;
    if (n <= 0) { msg = 'Te faltan <b>8 fragancias</b> para completar tu kit'; cta = 'Ver mi kit (0/8)'; }
    else if (n < 8) { var falta = 8 - n; msg = 'Ya elegiste <b>' + n + ' de 8</b> · te falta' + (falta > 1 ? 'n ' + falta : ' 1'); cta = 'Ver mi kit (' + n + '/8)'; }
    else { msg = '<b>¡Kit listo!</b> Ya puedes finalizar tu compra'; cta = 'Finalizar mi kit'; ready = true; }
    stickyMsg.innerHTML = msg;
    stickyCta.textContent = cta;
    stickyCta.classList.toggle('ready', ready);
    stickyEl.classList.add('show');
  }

  function openCart() {
    var bubble = $('#cart-icon-bubble') || $('a[href$="/cart"]');
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') { try { drawer.open(); return; } catch (e) { } }
    if (bubble) { bubble.click(); return; }
    window.location.href = '/cart';
  }

  /* ---------- init ---------- */
  function init() {
    if (!indexCards()) return;
    noResultsEl = $('#srk-noresults');
    countEl = $('#srk-count');
    collectEditorials();
    relabelAddButtons(); injectGridBanners(); injectKitButtons(); wireSilentAdd();
    wireNav(); wireSearch(); buildDrawer(); wireHelp(); buildFilterBar(); buildSticky();
    var clearBtn = $('#srk-noresults button');
    if (clearBtn) clearBtn.addEventListener('click', function () {
      state.nav = 'todos'; for (var k in state.filters) state.filters[k] = []; state.q = '';
      var inp = $('#srk-search-input'); if (inp) inp.value = '';
      $all('.srk-pill').forEach(function (p) { p.classList.remove('is-active'); });
      var t = $('.srk-pill[data-nav="todos"]'); if (t) t.classList.add('is-active');
      $all('.srk-fopt').forEach(function (b) { b.classList.remove('is-on'); });
      applyFilters();
    });
    applyFilters();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

